<template>
    <div v-if="isConfiguratorReady && !isLoading" class="col-span-2">
        <h3 class="mb">
            {{ currentArticle.designation }}
        </h3>
        <span class="text-gray-500">à partir de {{ getDisplayedPrice() }} net ht</span>
    </div>
</template>

<script>
import { formatPrice } from "../../helpers/priceHelper";
import { getLowestPriceFromProduct } from "../../helpers/projectHelper";

export default {
    name: "article-info",
    computed: {
        isLoading() {
            return this.$store.getters["project/isLoading"];
        },
        currentArticle() {
            return this.$store.getters["project/currentArticle"];
        },
        productConfiguration() {
            return this.$store.getters["project/productConfiguration"];
        },
        isConfiguratorReady() {
            return this.$store.getters["project/isConfiguratorReady"];
        },
    },
    methods: {
        getDisplayedPrice() {
            const minPrice = getLowestPriceFromProduct(this.productConfiguration);
            return formatPrice(minPrice);
        },
    },
};
</script>
